import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createAddress,
  getAddressesByUserId,
  updateUserAddress,
} from "../../redux/reducer/userAddressReducer";
import CustomInfoInput from "./customInfoInput";
import { useTranslation } from "react-i18next";
import { getMenuItemsLocationTo } from "../../constent/countries";
import CustomDropdownCountryAddress from "../sharedComponents/CustomDropdownCountryAddress";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import {
  DocumentArrowUpIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";

const SelectAddressSection = ({ onSelectAddress, tagIndex }) => {
  const [selectedTab, setSelectedTab] = useState(-1);
  const [formData, setFormData] = useState({});
  const [formDataAdd, setFormDataAdd] = useState({
    firstName: "",
    lastName: "",
    country: "",
    city: "",
    postalCode: "",
    state: "",
    fullAddress: "",
  });
  const [originalData, setOriginalData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const { addresses } = useSelector((state) => state.userAddress);
  const [selectAddressID, setSelectAddressID] = useState(
    selectedTab === 0 ? addresses?.user?.addresses[0]._id : null,
  );
  const { loading, error, successMessage } = useSelector(
    (state) => state.userAddress,
  );
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // console.log(selectAddressID)
  useEffect(() => {
    dispatch(getAddressesByUserId());
  }, [dispatch]);

  useEffect(() => {
    if (addresses?.user?.addresses?.length) {
      const address = addresses?.user?.addresses[selectedTab];
      if (address) {
        setFormData({
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          fullAddress: address.fullAddress || "",
          city: address.city || "",
          country: address.country || "",
          state: address.state || "",
          postalCode: address.postalCode || "",
          _id: address._id || null,
        });
        setOriginalData({
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          fullAddress: address.fullAddress || "",
          city: address.city || "",
          country: address.country || "",
          state: address.state || "",
          postalCode: address.postalCode || "",
          _id: address._id || null,
        });
        setIsEditing(false);
      }
    }
  }, [addresses, selectedTab]);

  const handleInputChange = (key) => (e) => {
    const newFormData = {
      ...formData,
      [key]: e.target.value,
    };
    setFormData(newFormData);

    const isChanged =
      JSON.stringify({
        firstName: newFormData.firstName,
        lastName: newFormData.lastName,
        fullAddress: newFormData.fullAddress,
        city: newFormData.city,
        country: newFormData.country,
        state: newFormData.state,
        postalCode: newFormData.postalCode,
      }) !==
      JSON.stringify({
        firstName: originalData.firstName,
        lastName: originalData.lastName,
        fullAddress: originalData.fullAddress,
        city: originalData.city,
        country: originalData.country,
        state: originalData.state,
        postalCode: originalData.postalCode,
      });

    setIsEditing(isChanged);
  };

  const handleTabClick = (index) => {
    setSelectedTab(index);
    const selectedId = addresses?.user?.addresses[index]?._id;
    setSelectAddressID(selectedId);
    // console.log("Selected Address ID:", selectedId);
    if (selectedId) {
      onSelectAddress(selectedId);
      tagIndex(selectedTab);
    }
    setIsEditing(false);
  };

  const menuItemsLocationTo = getMenuItemsLocationTo(t);
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formDataAdd.country ||
      !formDataAdd.firstName ||
      !formDataAdd.lastName ||
      !formDataAdd.city ||
      !formDataAdd.postalCode ||
      !formDataAdd.state ||
      !formDataAdd.fullAddress
    ) {
      setSubmitAttempted(true);
      return;
    }

    // Include userId in the payload
    if (addresses?.user?._id) {
      dispatch(createAddress({ ...formDataAdd }))
        .unwrap()
        .then((newAddress) => {
          const newIndex = addresses.user.addresses.length;
          // console.log(newAddress);
          setSelectedTab(newIndex);
          if (newAddress.data._id) {
            // console.log(
            //   "New Address ID:",
            //   newAddress?.data?.addresses[
            //     newAddress?.data?.addresses.length - 1
            //   ]?._id,
            // );
            setSelectAddressID(
              newAddress?.data?.addresses[
                newAddress?.data?.addresses.length - 1
              ]?._id,
            );
            onSelectAddress(
              newAddress?.data?.addresses[
                newAddress?.data?.addresses.length - 1
              ]?._id,
            );
          }

          dispatch(getAddressesByUserId());
          closeModal();
        })
        .catch((err) => {
          console.error("Error adding address:", err);
        });
    } else {
      alert(t("requiredAddress"));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataAdd({ ...formDataAdd, [name]: value });
    if (submitAttempted) {
      setSubmitAttempted(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSubmitAttempted(false);
    setFormDataAdd({
      firstName: "",
      lastName: "",
      fullAddress: "",
      country: "",
      city: "",
      postalCode: "",
      state: "",
    });
    // dispatch(clearError());
    // dispatch(clearSuccessMessage());
  };

  const handleUpdateAddress = () => {
    if (!formData._id || !isEditing) return;

    dispatch(
      updateUserAddress({
        addressId: formData._id,
        updatedData: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          country: formData.country,
          city: formData.city,
          postalCode: formData.postalCode,
          state: formData.state,
          fullAddress: formData.fullAddress,
        },
      }),
    )
      .unwrap()
      .then(() => {
        setOriginalData(formData); // 👈 مهم جدًا
        setIsEditing(false);
        dispatch(getAddressesByUserId());
      })
      .catch((err) => console.error(err));
  };

  // console.log(addresses);
  return (
    <div className="flex flex-col gap-5">
      {!addresses?.user?.addresses ||
      addresses?.user?.addresses.length === 0 ? (
        <div className="my-4 text-center">
          <p className="mb-4 text-gray-600">{t("noAddressInAccount")}</p>
          {/* Add Addresses */}
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="w-full px-4 py-2 font-medium text-black lg:text-lg bg-custom-yellow focus:outline-none focus:ring-2 focus:ring-custom-yellow"
          >
            {addresses?.user?.addresses.length === 0
              ? t("AddAddress")
              : t("Enteranotheraddress")}
          </button>
          {/* <button
            onClick={() => window.open("/my-account", "_blank")}
            className="px-4 py-2 text-black underline hover:underline-offset-0"
          >
            {t("AddAddress")}
          </button> */}
        </div>
      ) : (
        <>
          {/* Tabs */}
          <div className="flex justify-center gap-2 my-4">
            {addresses?.user?.addresses.map((address, index) => (
              <div
                key={address?._id}
                className={`flex items-center justify-between px-2 py-2 md:px-4 md:py-4 text-sm text-black duration-300 lg:text-base
            ${selectedTab === index ? "bg-custom-yellow" : "bg-white text-black border-2 border-gray-200  hover:bg-gray-400 hover:text-white"}
          `}
              >
                <button
                  onClick={() => handleTabClick(index)}
                  className={` ${selectedTab === index ? "" : ""}`}
                >
                  {t("AddressNo")} {index + 1}
                </button>
              </div>
            ))}
          </div>

          {/* Address Form */}
          {selectedTab >= 0 && formData && (
            <>
              <div className="flex justify-end gap-2 mb-3">
                <button
                  onClick={isEditing ? handleUpdateAddress : undefined}
                  className={`flex items-center gap-2 px-2 py-2 text-sm font-medium rounded-lg duration-300 ${
                    isEditing
                      ? "text-black bg-custom-yellow "
                      : "text-black bg-transparent cursor-text"
                  }`}
                >
                  <span className="text-black">
                    {isEditing ? t("Save") : t("edit")}
                  </span>
                  {isEditing ? (
                    <DocumentArrowUpIcon className="w-4 h-4 text-black " />
                  ) : (
                    <PencilSquareIcon className="w-4 h-4 text-black " />
                  )}
                </button>
                {/* <button
                  onClick={isEditing ? handleUpdateAddress : undefined}
                  disabled={!isEditing}
                  className={`px-3 py-1 text-sm rounded transition
      ${
        isEditing
          ? "bg-custom-yellow cursor-pointer"
          : "bg-gray-200 cursor-not-allowed opacity-60"
      }`}
                >
                  {isEditing ? "💾 Save" : "✏️ Edit"}
                </button> */}
              </div>

              <div className="flex gap-3">
                <CustomInfoInput
                  id="firstName"
                  placeholder={t("FirstName")}
                  label={t("FirstName")}
                  type="text"
                  value={formData.firstName}
                  onChange={handleInputChange("firstName")}
                  autoComplete="off"
                  icon={<i className="fas fa-user"></i>}
                  readOnly={false}
                />
                <CustomInfoInput
                  id="lastName"
                  placeholder={t("LastName")}
                  label={t("LastName")}
                  type="text"
                  value={formData.lastName}
                  onChange={handleInputChange("lastName")}
                  autoComplete="off"
                  icon={<i className="fas fa-user"></i>}
                  readOnly={false}
                />
              </div>

              <div className="flex gap-3">
                <CustomInfoInput
                  id="city"
                  label={t("Country")}
                  type="text"
                  placeholder={t("Country")}
                  value={
                    menuItemsLocationTo.find(
                      (item) => item.id === formData.country,
                    )?.name || t("calculateShippingSection.selectCountry")
                  }
                  onChange={handleInputChange("Country")}
                  autoComplete="off"
                  readOnly={false}
                />
                <CustomInfoInput
                  id="city"
                  label={t("City")}
                  type="text"
                  placeholder={t("City")}
                  value={formData.city}
                  onChange={handleInputChange("city")}
                  autoComplete="off"
                  icon={<i className="fas fa-city"></i>}
                  readOnly={false}
                />
              </div>

              <div className="flex gap-3">
                <CustomInfoInput
                  id="postalCode"
                  label={t("PostalCode")}
                  type="text"
                  placeholder={t("PostalCode")}
                  value={formData.postalCode}
                  onChange={handleInputChange("postalCode")}
                  autoComplete="off"
                  icon={<i className="fas fa-mail-bulk"></i>}
                  readOnly={false}
                />
                <CustomInfoInput
                  id="state"
                  label={t("State/Province")}
                  type="text"
                  placeholder={t("State")}
                  value={formData.state}
                  onChange={handleInputChange("state")}
                  autoComplete="off"
                  icon={<i className="fas fa-road"></i>}
                  readOnly={false}
                />
              </div>
              <div className="flex">
                <CustomInfoInput
                  id="fullAddress"
                  label={t("FullAddress")}
                  type="text"
                  placeholder={t("FullAddress")}
                  value={formData.fullAddress}
                  onChange={handleInputChange("fullAddress")}
                  autoComplete="off"
                  icon={<i className="fas fa-map-marked-alt"></i>}
                  readOnly={false}
                />
              </div>
            </>
          )}
          {/* Add Addresses */}
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="w-full px-4 py-2 font-medium text-black lg:text-lg bg-custom-yellow focus:outline-none focus:ring-2 focus:ring-custom-yellow"
          >
            {addresses?.length === 0
              ? t("AddAddress")
              : t("Enteranotheraddress")}
          </button>
        </>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-full max-w-2xl p-4 m-2 mt-8 bg-white rounded-lg shadow-lg lg:m-0 lg:mt-16 max-h-[80vh] overflow-scroll">
            <h2 className="mb-2 text-lg font-bold text-black">
              {t("EnterAddress")}
            </h2>
            {error && <p className="text-red-500">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="p-2 mb-2 text-black bg-blue-100 rounded-sm">
                <p className="mb-2 text-sm lg:text-base">
                  {t("addressTitleNotes")}
                </p>
                <ul className="px-6 text-xs list-disc lg:text-sm">
                  <li>
                    {t("addressNotes1")}
                    <br />
                    {t("addressNotes2")}
                  </li>
                  <li>{t("addressNotes3")}</li>
                </ul>
              </div>
              <div className="grid grid-cols-2 gap-2">
                {Object.keys(formDataAdd).map((key, index) =>
                  key !== "userId" ? (
                    <div
                      key={index}
                      className={key === "fullAddress" ? "col-span-2" : ""}
                    >
                      <label
                        htmlFor={key}
                        className={`block ${
                          key === "country" ? "mb-0" : "mb-2"
                        } text-xs lg:text-sm font-semibold text-gray-700`}
                      >
                        {key === "fullAddress"
                          ? t("FullAddress")
                          : key === "city"
                            ? t("City")
                            : key === "postalCode"
                              ? t("PostalCode")
                              : key === "state"
                                ? t("State")
                                : key === "firstName"
                                  ? t("FirstName")
                                  : key === "lastName"
                                    ? t("LastName")
                                    : ""}
                        {key === "country" ? (
                          <></>
                        ) : (
                          <span className="ml-1 text-red-500">*</span>
                        )}
                      </label>
                      {key === "fullAddress" ? (
                        <textarea
                          id={key}
                          name={key}
                          value={formDataAdd[key]}
                          onChange={handleChange}
                          className={`w-full h-20 px-2 py-1 text-black bg-white border rounded-lg lg:px-5 lg:py-3 placeholder:text-black lg:placeholder:text-sm placeholder:text-xs ${
                            submitAttempted && !formDataAdd[key]
                              ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                              : "border-gray-300"
                          }`}
                          rows={4}
                          required
                        />
                      ) : key === "country" ? (
                        <CustomDropdownCountryAddress
                          title={t("Country")}
                          menuItems={menuItemsLocationTo}
                          textColor="custom-gray"
                          onSelect={(item) => {
                            setFormDataAdd((prev) => ({
                              ...prev,
                              country: item.id,
                            }));
                            // Remove error when selecting
                            if (submitAttempted) {
                              setSubmitAttempted(false);
                            }
                          }}
                          selected={formDataAdd.country}
                          font={true}
                          add_addresses={true}
                          required={true}
                          showError={submitAttempted && !formDataAdd.country}
                          errorMessage={t("pleaseSelectCountry")}
                        />
                      ) : (
                        <input
                          type="text"
                          id={key}
                          name={key}
                          value={formDataAdd[key]}
                          onChange={handleChange}
                          className={`w-full px-2 py-1 text-black bg-white border rounded-lg lg:px-5 lg:py-3 placeholder:text-black placeholder:text-sm ${
                            submitAttempted && !formDataAdd[key]
                              ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                              : "border-gray-300"
                          }`}
                          required
                        />
                      )}
                      {/* Error message for regular fields */}
                      {submitAttempted &&
                        !formDataAdd[key] &&
                        key !== "country" && (
                          <p className="mt-1 text-sm text-red-500">
                            {t("thisFieldIsRequired") || "هذا الحقل مطلوب"}
                          </p>
                        )}
                    </div>
                  ) : null,
                )}
              </div>
              <div className="flex justify-between mt-2">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 text-sm font-bold text-black duration-300 bg-gray-300 lg:text-base hover:bg-gray-400 focus:outline-none"
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  className={`${
                    loading
                      ? "bg-custom-yellow"
                      : "bg-custom-yellow hover:bg-custom-yellow"
                  } text-white font-bold  focus:outline-none focus:ring-2 focus:ring-custom lg:text-base text-sm`}
                  disabled={loading}
                >
                  {loading ? (
                    <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
                  ) : (
                    <button
                      type="submit"
                      className="px-4 py-2 text-black duration-300 bg-custom-yellow hover:bg-yellow-400"
                    >
                      {t("Submit")}
                    </button>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectAddressSection;
